import Vue from 'vue'
import router from './router'
import vuetify from './plugins/vuetify'
import VueCookies from 'vue-cookies'
import './plugins'
import store from './store'
import { sync } from 'vuex-router-sync'
import App from './App.vue'

import '@babel/polyfill'
import '@mdi/font/css/materialdesignicons.css'
import axios from 'axios'
import moment from 'moment'
import i18n from './i18n'
import { SchedulePlugin } from '@syncfusion/ej2-vue-schedule'

Vue.config.productionTip = false

Vue.filter('formatDate', function (value) {
  if (value) {
    return moment(value).format('YYYY-MM-DD HH:mm')
  } else {
    return '-'
  }
})

Vue.filter('formatDateOnlyDate', function (value) {
  if (value) {
    return moment(value).format('YYYY-MM-DD')
  } else {
    return '-'
  }
})

Vue.prototype.$http = axios

Vue.use(VueCookies)
Vue.use(SchedulePlugin)

sync(store, router)

new Vue({
  i18n,
  router,
  vuetify,
  store,
  render: h => h(App),
}).$mount('#app')
